module.exports = __webpack_public_path__ + "img/创客页面.07840a9d.png";